function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

  const headerMenus = document.getElementById('Details-menu-drawer-container');
  const selectIcon = headerMenus.firstElementChild.firstElementChild.childNodes[1]; 
 
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
     });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
       selectIcon.style.display = "none";
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('no-scroll');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    selectIcon.style.display = "block";
    document.body.classList.remove('no-scroll');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/* Accordion1 JS  Start*/
        //   const acc = document.getElementsByClassName("accordion");
        //   const accordionSubhead = document.querySelector(".accordion-subhead");
        //   const accordionHead = document.querySelector(".accordion-head");
        //   const arrowup = document.querySelector(".arrowup");
        //   const subNew = document.querySelector(".accordion-subhead2")
        //   const accordionImage = document.querySelector(".accordion-image");
       

        // for (let i = 0; i < acc.length; i++) {
        //     acc[i].addEventListener("click", function (e) {
        //         e.preventDefault();
                            
        //         this.classList.toggle("active");
                

        //         let panel = this.nextElementSibling;
        //         console.log(panel, "PANELLL")

        //         if (panel.style.display === "block") {
        //             panel.style.display = "none";
        //             accordionHead.style.display = "block";
        //             this.style.fontSize = "16px";
        //             arrowup.style.transform = "rotate(180deg)";
        //             accordionSubhead.classList.remove("transitionLeft");
        //             accordionSubhead.classList.add("transitionRight");
        //             subNew.classList.add("transitionRight2");
        //             subNew.classList.remove("transitionLeft2");
        //             accordionImage.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1.png)";
                    
                    

        //         } else {
        //              panel.style.display = "block";
                    
        //             this.style.fontSize = "32px";
        //             this.style.lineHeight = "36px";                    
        //             accordionHead.style.display = "none";
        //             arrowup.style.transform = "rotate(0deg)";
        //             accordionSubhead.classList.add("transitionLeft");
        //             accordionSubhead.classList.remove("transitionRight");
        //             subNew.classList.add("transitionLeft2");
        //             subNew.classList.remove("transitionRight2");
        //             accordionImage.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-2.png)";

        //         }
        //     });
        // }

        const accAct1 = document.querySelector('.accordion-act-sec');
        if (accAct1){
                
                const accSingTrig1 = accAct1.querySelectorAll('.acc-single-trigger');
               
                 


            accSingTrig1.forEach(trigger => trigger.addEventListener('click', toggleAcc1));
          
              function toggleAcc1() {

            const thisItem = this.parentNode;

            const actItems1 = accAct1.querySelectorAll('.act-item');
            const accordionHead = document.querySelector(".accordion-head");
            const accordionSubhead = document.querySelector(".accordion-subhead");
            const faqIcon1 = document.querySelector(".faq-icon");
            const subNew = document.querySelector(".accordion-subhead2");
            const accordionImage = document.querySelector(".accordion-image"); 
            const accAction1 = document.querySelector('.accordion-action');
                
            actItems1.forEach(item => {

                if (thisItem === item) {
                    thisItem.classList.toggle('is-open');
                    thisItem.firstElementChild.childNodes[1].style.transform = "rotate(0deg)";
                    accordionSubhead.classList.remove("transitionLeft");
                    accordionSubhead.classList.add("transitionRight");
                    subNew.classList.add("transitionRight2");
                    subNew.classList.remove("transitionLeft2");
                    accAction1.style.height = "562px";
                    thisItem.firstElementChild.style.fontSize = "16px";
                    thisItem.firstElementChild.style.lineHeight = "16px";
                    

                    if (thisItem.classList.contains('is-open')) {
                      accordionHead.style.display = "none";
                      accordionSubhead.classList.add("transitionLeft");
                      accordionSubhead.classList.remove("transitionRight");
                      subNew.classList.add("transitionLeft2");
                      subNew.classList.remove("transitionRight2");
                      thisItem.firstElementChild.style.fontSize = "26px";
                      thisItem.firstElementChild.style.lineHeight = "26px";
                      accordionImage.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-2.png)";
                      if(thisItem.parentNode.lastElementChild === item){
                        thisItem.firstElementChild.style.borderRadius = "0px";
                        thisItem.querySelector('.accordion-single-content').style.borderRadius = "0px 0px 20px 20px";
                      }
                      
                        
                    } else {
                        accordionHead.style.display = "block";
                        accordionImage.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1.png)";
                      thisItem.firstElementChild.childNodes[1].style.transform = "rotate(180deg)";
                      if(thisItem.parentNode.lastElementChild === item){
                        thisItem.firstElementChild.style.borderRadius = "0px 0px 20px 20px";
                      }
                    }

                  
                    return;
                } else {
                    item.classList.remove('is-open');
                    item.firstElementChild.childNodes[1].style.transform = "rotate(180deg)";
                    item.firstElementChild.style.fontSize = "16px";
                    item.firstElementChild.style.lineHeight = "16px";
                    if(item.parentNode.lastElementChild === item){
                        item.firstElementChild.style.borderRadius = "0px 0px 20px 20px";
                     }
                   

                }
                

            });
        }
 }
      

    
  /* Accordion1 JS  Finish*/

/* Accordion2 JS Start*/



        const accAct3 = document.querySelector('.accordion-act-sec3');
        if (accAct3){
                
                const accSingTrig3 = accAct3.querySelectorAll('.acc-single-trigger3');
               
        
                accSingTrig3.forEach(trigger => trigger.addEventListener('click', toggleAcc3));
        
        
                function toggleAcc3() {
                    const actItems3 = accAct3.querySelectorAll('.act-item3');
                    const thisItem = this.parentNode;
                    const faqIcon3 = document.querySelector(".faq-icon");
                    const accordionHead3 = document.querySelector(".accordion-head3");
                    const accordionSubhead3 = document.querySelector(".accordion-subhead4");
                    const subNew3 = document.querySelector(".accordion-subhead5");
                    const accTitle3 = document.querySelector(".accordion_new2");
                    const accordionImage3 = document.querySelector(".accordion-image3");
                    const accAction3 = document.querySelector('.accordion-action3');
        
        
                    actItems3.forEach(item => {
        
                        if (thisItem === item) {
                            thisItem.classList.toggle('is-open');
                            thisItem.firstElementChild.childNodes[1].style.transform = "rotate(0deg)";
                            accordionSubhead3.classList.remove("transitionLeft4");
                            accordionSubhead3.classList.add("transitionRight4");
                            subNew3.classList.add("transitionRight5");
                            subNew3.classList.remove("transitionLeft5");
                            thisItem.firstElementChild.style.fontSize = "16px";
                            thisItem.firstElementChild.style.lineHeight = "16px";
                            accAction3.style.height = "562px";

                            if (thisItem.classList.contains('is-open')) {
                              accordionHead3.style.display = "none";
                              accordionSubhead3.classList.add("transitionLeft4");
                              accordionSubhead3.classList.remove("transitionRight4");
                              subNew3.classList.add("transitionLeft5");
                              subNew3.classList.remove("transitionRight5");
                              thisItem.firstElementChild.style.fontSize = "26px";
                              thisItem.firstElementChild.style.lineHeight = "26px";
                              accordionImage3.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-6.png)";
                              if(thisItem.parentNode.lastElementChild === item){
                                thisItem.firstElementChild.style.borderRadius = "0px";
                                thisItem.querySelector('.accordion-single-content').style.borderRadius = "0px 0px 20px 20px";
                              }
                            } else {
                                accordionHead3.style.display = "block";
                                accordionImage3.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-5.png)";
                              thisItem.firstElementChild.childNodes[1].style.transform = "rotate(180deg)";
                              if(thisItem.parentNode.lastElementChild === item){
                                thisItem.firstElementChild.style.borderRadius = "0px 0px 20px 20px";
                              }
                            }

                          
                            return;
                        } else {
                            item.classList.remove('is-open');
                            item.firstElementChild.childNodes[1].style.transform = "rotate(180deg)";
                            item.firstElementChild.style.fontSize = "16px";
                            item.firstElementChild.style.lineHeight = "16px";
                            if(item.parentNode.lastElementChild === item){
                              item.firstElementChild.style.borderRadius = "0px 0px 20px 20px";
                             }
                        }
                        
        
                    });
                }
        }
                

        //     const acc3 = document.getElementsByClassName("accordion3");
        
        //     const accordionSubhead3 = document.querySelector(".accordion-subhead4");
        //     const accordionHead3 = document.querySelector(".accordion-head3");
        //     const arrowup3 = document.querySelector(".arrowup3");
        //     const subNew3 = document.querySelector(".accordion-subhead5")
        //     const accordionImage3 = document.querySelector(".accordion-image3");
      
      

        // for (let i = 0; i < acc3.length; i++) {
        //     acc3[i].addEventListener("click", function (e) {
        //         e.preventDefault();
        //         this.classList.toggle("active3");

        //         let panel3 = this.nextElementSibling;


        //         if (panel3.style.display === "block") {
        //             panel3.style.display = "none";
        //             accordionHead3.style.display = "block";
        //             this.style.fontSize = "16px";
        //             arrowup3.style.transform = "rotate(180deg)";
        //             accordionSubhead3.classList.remove("transitionLeft4");
        //             accordionSubhead3.classList.add("transitionRight4");
        //             subNew3.classList.add("transitionRight5");
        //             subNew3.classList.remove("transitionLeft5");
        //             accordionImage3.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-5.png)";

        //         } else {
        //             panel3.style.display = "block";
        //             this.style.fontSize = "36px";
        //             this.style.lineHeight = "36px";
        //             accordionHead3.style.display = "none";
        //             arrowup3.style.transform = "rotate(0deg)";
        //             accordionSubhead3.classList.add("transitionLeft4");
        //             accordionSubhead3.classList.remove("transitionRight4");
        //             subNew3.classList.add("transitionLeft5");
        //             subNew3.classList.remove("transitionRight5");
        //             accordionImage3.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-6.png)";

        //         }
        //     });
        // }

  /* Accordion2 JS  Finish*/


/* Accordion3 JS  Start*/

        const accAct2 = document.querySelector('.accordion-act-sec2');
        if(accAct2){
                
                const accSingTrig2 = accAct2.querySelectorAll('.acc-single-trigger2');
                
        
                accSingTrig2.forEach(trigger => trigger.addEventListener('click', toggleAcc2));

                   function toggleAcc2() {

                const thisItem = this.parentNode;
                const actItems2 = accAct2.querySelectorAll('.act-item2');
                const faqIcon2 = document.querySelector(".faq-icon");
                const accordionHead2 = document.querySelector(".accordion-head2");
                const accordionSubhead2 = document.querySelector(".accordion-subhead1");
                const subNew2 = document.querySelector(".accordion-subhead3");
                const accTitle2 = document.querySelector(".accordion_new2");
                const accordionImage2 = document.querySelector(".accordion-image2");
                const accAction2 = document.querySelector('.accordion-action2');   

            actItems2.forEach(item => {

                if (thisItem === item) {
                    
                    thisItem.firstElementChild.childNodes[1].style.transform = "rotate(0deg)";
                     accordionSubhead2.classList.remove("transitionLeft1");
                     accordionSubhead2.classList.add("transitionRight1");
                     subNew2.classList.add("transitionRight3");
                     subNew2.classList.remove("transitionLeft3");
                    thisItem.firstElementChild.style.fontSize = "16px";
                    thisItem.firstElementChild.style.lineHeight = "16px";
                    accAction2.style.height = "562px";
                    thisItem.classList.toggle('is-open');

                      if (thisItem.classList.contains('is-open')) {
                          accordionHead2.style.display = "none";
                          accordionSubhead2.classList.add("transitionLeft1");
                          accordionSubhead2.classList.remove("transitionRight1");
                          subNew2.classList.add("transitionLeft3");
                          subNew2.classList.remove("transitionRight3");
                          thisItem.firstElementChild.style.fontSize = "26px";
                          thisItem.firstElementChild.style.lineHeight = "26px";
                          accordionImage2.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-4.png)";
                          if(thisItem.parentNode.lastElementChild === item){
                            thisItem.firstElementChild.style.borderRadius = "0px";
                            thisItem.querySelector('.accordion-single-content').style.borderRadius = "0px 0px 20px 20px";
                          }
                      } else {
                          accordionHead2.style.display = "block";
                          accAction2.style.height = "470px";
                          thisItem.firstElementChild.style.fontSize = "16px";
                          thisItem.firstElementChild.style.lineHeight = "16px";
                          thisItem.firstElementChild.childNodes[1].style.transform = "rotate(180deg)";
                          accordionImage2.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-2.png)";
                        if(thisItem.parentNode.lastElementChild === item){
                          thisItem.firstElementChild.style.borderRadius = "0px 0px 20px 20px";
                        }
                      }

                  
                    return;
                } else {
                    item.classList.remove('is-open');
                    // item.firstElementChild.childNodes[1].style.transform = "rotate(180deg)";
                    item.firstElementChild.style.fontSize = "16px";
                    item.firstElementChild.style.lineHeight = "16px";
                   if(item.parentNode.lastElementChild === item){
                     item.firstElementChild.style.borderRadius = "0px 0px 20px 20px";
                   }
                }
             });
        }
          
        }
               


     

        // const acc2 = document.getElementsByClassName("accordion2");
        
        //     const accordionSubhead2 = document.querySelector(".accordion-subhead1");
        //     const accordionHead2 = document.querySelector(".accordion-head2");
        //     const arrowup2 = document.querySelector(".arrowup2");
        //     const subNew2 = document.querySelector(".accordion-subhead3")
        //     const accordionImage2 = document.querySelector(".accordion-image2");
      

        // for (let i = 0; i < acc2.length; i++) {
        //     acc2[i].addEventListener("click", function (e) {
        //         e.preventDefault();
        //         this.classList.toggle("active2");

        //         let panel2 = this.nextElementSibling;


        //         if (panel2.style.display === "block") {
        //             panel2.style.display = "none";
        //             accordionHead2.style.display = "block";
        //             this.style.fontSize = "16px";
        //             arrowup2.style.transform = "rotate(180deg)";
        //             accordionSubhead2.classList.remove("transitionLeft1");
        //             accordionSubhead2.classList.add("transitionRight1");
        //             subNew2.classList.add("transitionRight3");
        //             subNew2.classList.remove("transitionLeft3");
        //             accordionImage2.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-4.png)";

        //         } else {
                  
        //             panel2.style.display = "block";
        //             this.style.fontSize = "36px";
        //             this.style.lineHeight = "36px";
        //             accordionHead2.style.display = "none";
        //             arrowup2.style.transform = "rotate(0deg)";
        //             accordionSubhead2.classList.add("transitionLeft1");
        //             accordionSubhead2.classList.remove("transitionRight1");
        //             subNew2.classList.add("transitionLeft3");
        //             subNew2.classList.remove("transitionRight3");
        //             accordionImage2.style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0693/9017/2437/files/bathroom1_1-2.png)";

        //         }
        //     });
        // }
  /* Accordion3 JS  Finish*/

/******  Contact FAQ Section   ******/

        const accSingle = document.querySelector('.js-acc-single');
        
        if (accSingle ) {
          
          const accSingleTriggers = accSingle.querySelectorAll('.js-acc-single-trigger');
          const faqIcon = document.querySelector(".faq-icon");
          const firstChild = accSingle.firstElementChild;
          const firstIcon = accSingle.firstElementChild.childNodes[1].firstElementChild;
          firstChild.classList.add('is-open');
          firstIcon.style.transform = "rotate(0deg)"
   
          accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));
       

        function toggleAccordion() {

            const thisItem = this.parentNode;

            // console.log(thisItem.firstElementChild.childNodes[1]);
             const items = accSingle.querySelectorAll('.js-acc-item');
            
                items.forEach(item => {
                if (thisItem === item) {
                    thisItem.classList.toggle('is-open');
                    thisItem.firstElementChild.childNodes[1].style.transform = "rotate(0deg)";
                    return;
                }
                item.classList.remove('is-open');
                item.firstElementChild.childNodes[1].style.transform = "rotate(180deg)";

            });
                     
        }
           }
/******  Contact FAQ Section   ******/

/* Product Detail Description JS*/

        const descSingle = document.querySelector('.desc-acc-single');
       
        if (descSingle){
                
                const descSingleTriggers = descSingle.querySelectorAll('.desc-acc-single-trigger');
                const desIcon = document.querySelector(".desc-icon");
                const descFirstChild = descSingle.firstElementChild;
                const descFirstIcon = descSingle.firstElementChild.childNodes[1].firstElementChild;
        
                descSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleDescAccordion));
        }
     


        function toggleDescAccordion() {
         
            const prodItem = this.parentNode;

            const prod_items = descSingle.querySelectorAll('.desc-acc-item');
          
             prod_items.forEach(item2 => {
                if (prodItem === item2) {
                    prodItem.classList.toggle('is-open');
                    prodItem.firstElementChild.childNodes[1].style.transform = "rotate(45deg)";
                    return;
                }

                item2.classList.remove('is-open');
                item2.firstElementChild.childNodes[1].style.transform = "rotate(90deg)";

            });
        
           
        }

/* Product Detail Description JS*/